import { WaterFinalInvoiceServiceDto } from '../types/water-final-invoice-service-dto';
import { BaseService } from '@app/services/base/classes/base-service';
import { FilingOption } from '@app/services/filing-options/types/filing-options';

export class WaterFinalInvoiceService extends BaseService {
    constructor(partial: WaterFinalInvoiceServiceDto) {
        super(partial);
        this.filingOption = partial?.filingOption;
    }

    filingOption: FilingOption;
}
